import { styled, Typography } from '@mui/material';

import { PsSelectTuner } from 'stencilSetup';

export const InNetworkPillStyled = styled(Typography)({
  borderRadius: '4px',
  background: '#E7F4E6',
  display: 'flex',
  alignItems: 'center',
  padding: '4px 8px 4px 8px',
  width: 'fit-content',
});

export const ContentNameInfoStyled = styled('div')({
  marginBottom: '14px',
});

export const SearchResultsContentCardStyled = styled('div')({
  width: 'calc(100vw - 48px)',
  '@media (min-width: 744px)': {
    width: 'auto',
  },
});

export const ChoosePCPDrawerFormContentStyled = styled('div')({
  '@media (min-width: 744px)': {
    columnGap: '3rem',
  },
});

export const MilesPsSelectTunerStyled = styled(PsSelectTuner)({
  '.select-wrap': {
    width: '100px',
  },
});

export const SearchProviderButtonStyled = styled('div')({
  alignSelf: 'flex-end',
});

export const GoogleMapPositionStyled = styled('div')({
  top: '19rem',
});